// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2MsGb","Divider":"Divider--1M5kI","InputCol":"InputCol--20gp2","Link":"Link--3ruzq"};